import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["checked"]
const _hoisted_2 = {
  class: "form-check-label",
  for: "check-box-id"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckBox',
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'primary',
    },
  },
  setup(__props) {

  const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      id: "check-box-id",
      type: "checkbox",
      class: _normalizeClass([`form-check-input form-check-input--${props.type}`, 'me-2']),
      checked: props.modelValue,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', !props.modelValue)))
    }, null, 42, _hoisted_1),
    _createElementVNode("label", _hoisted_2, _toDisplayString(props.label), 1)
  ]))
}
}

})